import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleCreateProject(
  state: State,
  { project, zone }: Boundaries["createProject"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    zones: req.zones.map((z) =>
      z.uuid === zone.uuid
        ? {
            ...z,
            projects: [...z.projects, { ...project, numberOfElements: 0 }],
          }
        : z,
    ),
  }));
}
export { handleCreateProject };
